import { devicesRef, pharmaciesRef, deviceRef, databaseRef } from "../../../Config/FirebaseDatabase";
import moment from 'moment';
import { DirectionType } from "../../DeviceBrowser/DirectionType";
import { pad } from '../../../Config/Helpers';

export const FETCH_PHARMACIES_FULFILLED = 'FETCH_PHARMACIES_FULFILLED';
export const FETCH_PHARMACIES_REJECTED = 'FETCH_PHARMACIES_REJECTED';
export const FETCH_PHARMACIES_PENDING = 'FETCH_PHARMACIES_PENDING';
export const FETCH_PHARMACY_PENDING = 'FETCH_PHARMACY_PENDING';
export const FETCH_PHARMACY_FULFILLED = 'FETCH_PHARMACY_FULFILLED';
export const FETCH_PHARMACY_REJECTED = 'FETCH_PHARMACY_REJECTED';
export const SEARCH_PHARMACIES_FULFILLED = 'SEARCH_PHARMACIES_FULFILLED';

export const SORT_PHARMACIES_FULFILLED = 'SORT_PHARMACIES_FULFILLED';
export const SORT_PHARMACIES_PENDING = 'SORT_PHARMACIES_PENDING';

export const FILTER_PHARMACIES_FULFILLED = 'FILTER_PHARMACIES_FULFILLED';
export const FILTER_PHARMACIES_PENDING = 'FILTER_PHARMACIES_PENDING';

export const UPDATE_PHARMACY_FULFILLED = 'UPDATE_PHARMACY_FULFILLED';
export const UPDATE_PHARMACY_PENDING = 'UPDATE_PHARMACY_PENDING';
export const UPDATE_PHARMACY_REJECTED = 'UPDATE_PHARMACY_REJECTED';

export const UPDATE_PHARMACY_ALIASES_FULFILLED = 'UPDATE_PHARMACY_ALIASES_FULFILLED';
export const UPDATE_PHARMACY_ALIASES_PENDING = 'UPDATE_PHARMACY_ALIASES_PENDING';
export const UPDATE_PHARMACY_ALIASES_REJECTED = 'UPDATE_PHARMACY_ALIASES_REJECTED';

export const ADD_PHARMACY_PENDING = 'ADD_PHARMACY_PENDING';
export const ADD_PHARMACY_FULFILLED = 'ADD_PHARMACY_FULFILLED';
export const ADD_PHARMACY_REJECTED = 'ADD_PHARMACY_REJECTED';

// ACTION GENERATORS

function generateEvents(device) {
    var events = [];

    if (device.hasOwnProperty('DeviceDetails')) {
        if (device['DeviceDetails'].hasOwnProperty('latest') && device['DeviceDetails'].hasOwnProperty('counts')) {
            let latestEvents = device['DeviceDetails']['latest'];
            let latestEventCounts = device['DeviceDetails']['counts'];

            let latestEventKeys = Object.keys(latestEvents);
            
            latestEventKeys.forEach((key) => {
                let countKey = key.replace("Latest_", "");

                let count = latestEventCounts[countKey];
                let latestEvent = latestEvents[key];
                let event = {name: countKey, count: count, latest: latestEvent};
                events.push(event);
            })

            events.sort((event1, event2) => {
                let event1Date = moment(event1.latest);
                let event2Date = moment(event2.latest);
                return moment(event1Date).isAfter(event2Date);
            })

            return events;
        }
    }

    return [];
}

function pharmacyProperties(pharmacy) {
    let testPharmacy = false; 
    let unattachedPharmacy = false; 
    let batteryLow = false;
    let deactivatedPharmacy = false;
    let notReceivingData = false;

    if (pharmacy.hasOwnProperty("devices")) {
        let deviceKeys = Object.keys(pharmacy.devices);
        
        deviceKeys.forEach(deviceKey => {
            let device = pharmacy.devices[deviceKey];

            let battery = -1;
            if (device.hasOwnProperty("DeviceDetails")) {
                if (device.DeviceDetails.hasOwnProperty("dynamicDevice")) {
                    battery = device.DeviceDetails.dynamicDevice.batteryLevel;
                } else if (!device.isDeactivated && !device.isTest) {
                    notReceivingData = true;
                }
            } else if (!device.isDeactivated && !device.isTest)  {
                notReceivingData = true;
            }

            if (battery != -1 && battery < 0.25) {
                batteryLow = true;
            }
            
        })
    } else {
        if (!pharmacy.hasOwnProperty("deviceUuids")) {
            unattachedPharmacy = true;
        }
    }

    if (pharmacy.isTest) {
        testPharmacy = true;
    }

    if (pharmacy.isDeactivated) {
        deactivatedPharmacy = true;
    }

    return { 'testPharmacy': testPharmacy, 'unattachedPharmacy' : unattachedPharmacy, 'batteryLow' : batteryLow, 'deactivatedPharmacy' : deactivatedPharmacy, 'notReceivingData' : notReceivingData}
}


const fetchPharmaciesAction = () => (dispatch) => {
    dispatch({
        type: FETCH_PHARMACIES_PENDING,
    });

    let newPharmacies = [];

    // Retrieve all the Pharmacies that we have.
    devicesRef.once('value').then(deviceSnapshot => {
        let devices = deviceSnapshot.val();

        pharmaciesRef.once('value').then(pharmacySnapshot => {
            let pharmacies = pharmacySnapshot.val();

            // If the Pharmacy has any attached devices, fetch these.
            Object.keys(pharmacies).forEach(pharmacyFirebaseKey => {
                let pharmacy = pharmacies[pharmacyFirebaseKey];
                pharmacy['id'] = pharmacyFirebaseKey
                
                if (pharmacy.hasOwnProperty('deviceUuids')) {
                    let deviceUuids = Object.keys(pharmacy.deviceUuids);
    
                    if (deviceUuids.length > 0) {
                        // Search the devices that we fetched for the corresponding devices for this pharmacy and attach it to the pharmacy.
                        deviceUuids.forEach(deviceUuid => {
                            let attachedDeviceFirebaseId = Object.keys(devices).filter(deviceKey => {
                                let device = devices[deviceKey];
                                return device.LatestSetupPharmacyId === deviceUuid
                            });

                            if(attachedDeviceFirebaseId.length > 0) {
                                let device = devices[attachedDeviceFirebaseId[0]];
                                
                                // If the pharmacy doesn't already keep track of its devices...
                                if (!pharmacy.hasOwnProperty('devices')) {
                                    pharmacy['devices'] = {};
                                }

                                let events = generateEvents(device);
                                device['eventSummary'] = events;

                                pharmacy['devices'][deviceUuid] = device;
                            }
                        })
                        
                    }
                }

                pharmacy['properties'] = pharmacyProperties(pharmacy);
                
                newPharmacies.push(pharmacy);
            });

            dispatch({
                type: FETCH_PHARMACIES_FULFILLED,
                payload: newPharmacies
            });
        }).catch(error => {
            dispatch({
                type: FETCH_PHARMACIES_REJECTED,
            });
        });
    }).catch(error => {
        dispatch({
            type: FETCH_PHARMACIES_REJECTED,
        });
    });
};


const sortPharmaciesAction = (sortType, directionType) => (dispatch) => {
    let payload = {'sortType': sortType, 'directionType': directionType};

    dispatch({
        type: SORT_PHARMACIES_PENDING,
    });

    dispatch({
        type: SORT_PHARMACIES_FULFILLED,
        payload: payload
    });
};


const addPharmacyAction = (mdmId, campaignName) => (dispatch) => {
    let newPharmacy = { 'mdmId' : mdmId, 'campaignName' : campaignName };


    if (mdmId < 2) {
        mdmId = pad(mdmId, 3)
    }

    let generatedId = mdmId + " - " + campaignName;

    newPharmacy['properties'] = pharmacyProperties(newPharmacy);
    newPharmacy['id'] = generatedId;

    dispatch({
        type: ADD_PHARMACY_PENDING,
    });

    let nodePath = 'Pharmacies/' + generatedId;

    databaseRef.child(nodePath).set(newPharmacy, (error) => {
        if(error) {
            // The write failed...
            dispatch({
                type: ADD_PHARMACY_REJECTED,
            });
        } else {
            dispatch({
                type: ADD_PHARMACY_FULFILLED,
                payload: newPharmacy
            });
        }
    });
};



const filterPharmaciesAction = (filterType) => (dispatch) => {
    let payload = {'filterType': filterType};

    dispatch({
        type: FILTER_PHARMACIES_PENDING,
    });

    dispatch({
        type: FILTER_PHARMACIES_FULFILLED,
        payload: payload
    });
};



const updatePharmacyAction = (entityUpdate, device) => (dispatch) => {
    dispatch({
        type: UPDATE_PHARMACY_PENDING,
    });
    
    let deviceId = device.id;
    let nodePath = 'Pharmacies/' + deviceId;

    databaseRef.child(nodePath).update(entityUpdate, (error) => {
        if (error) {
            // The write failed...
            dispatch({
                type: UPDATE_PHARMACY_REJECTED,
            });
        } else {
            // Data updated successfully!
            setTimeout(() => { 
                dispatch({
                    type: UPDATE_PHARMACY_FULFILLED,
                    payload: entityUpdate
                });
            }, 1000);
            
        }
    });
};


const updatePharmacyAliasesAction = (aliases, pharmacy) => (dispatch) => {
    dispatch({
        type: UPDATE_PHARMACY_ALIASES_PENDING,
    });
    
    let pharmacyId = pharmacy.id;
    let nodePath = 'Pharmacies/' + pharmacyId + "/aliases";

    databaseRef.child(nodePath).update(aliases, (error) => {
        if (error) {
            // The write failed...
            dispatch({
                type: UPDATE_PHARMACY_ALIASES_REJECTED,
            });
        } else {
            // Data updated successfully!
            dispatch({
                type: UPDATE_PHARMACY_ALIASES_FULFILLED,
                payload: {'aliases' : Object.assign({}, pharmacy.aliases, aliases)}
            });
        }
    });
};

const searchPharmaciesAction = (searchText) => (dispatch) => {
    dispatch({
        type: SEARCH_PHARMACIES_FULFILLED,
        payload: searchText
    });
};


const fetchPharmacyAction = (pharmacyUuid) => (dispatch) => {
    dispatch({
        type: FETCH_PHARMACY_PENDING,
    });

    databaseRef.child("Pharmacies/" + pharmacyUuid).once('value', pharmacySnapshot => {
        let pharmacy = pharmacySnapshot.val();

        pharmacy['id'] = pharmacyUuid;

        if (pharmacy !== undefined && pharmacy !== null) {
            let devicePromises = [];
    
            if (pharmacy.hasOwnProperty('deviceUuids')) {
                let deviceUuids = Object.keys(pharmacy.deviceUuids);
    
                // Create a series of Firebase promises to fetch the devies attached to the pharmacy.     
                if (deviceUuids.length > 0) {
                    deviceUuids.forEach(deviceUuid => {
                        devicePromises.push(deviceRef.equalTo(deviceUuid).once('value'));
                    });
    
                    let count = 0;
        
                    Promise.all(devicePromises).then((deviceSnapshots) => {
                        deviceSnapshots.forEach(deviceSnapshot => {
                            let value = deviceSnapshot.val();

                            if (!pharmacy.hasOwnProperty('devices')) {
                                pharmacy['devices'] = {};
                            }

                            // A device may be added without it existing in the LastSetupDeviceUUID node yet.
                            if (value !== undefined && value !== null) {
                                let deviceKey = Object.keys(value);
                                let device = value[deviceKey];
        
                                let deviceUuid = deviceUuids[count];
        
                                // Generate the events for the device
                                let events = generateEvents(device);
        
                                if (events.length > 0) {
                                    device['eventSummary'] = events;
                                }
                                
                                pharmacy['devices'][deviceUuid] = device;
        
                            } else {
                                // If the device doesn't exist yet, then add a placeholder device.
                                let deviceUuid = deviceUuids[count];
                                let device = {'LatestSetupPharmacyId' : deviceUuid};
                                pharmacy['devices'][deviceUuid] = device;
                            }

                            count += 1;
                        });
    
                        dispatch({
                            type: FETCH_PHARMACY_FULFILLED,
                            payload: pharmacy
                        });
                    })
                }
            } else {
                dispatch({
                    type: FETCH_PHARMACY_FULFILLED,
                    payload: pharmacy
                });
            }
        } else {
            dispatch({
                type: FETCH_PHARMACY_REJECTED,
            });
        }

       
    })
};

// EXPORT ACTIONS
export {fetchPharmaciesAction as fetchPharmacies, 
        fetchPharmacyAction as fetchPharmacy, 
        searchPharmaciesAction as searchPharmacies, 
        updatePharmacyAction as updatePharmacy,
        sortPharmaciesAction as sortPharmacies,
        updatePharmacyAliasesAction as updatePharmacyAliases,
        filterPharmaciesAction as filterPharmacies,
        addPharmacyAction as addPharmacy
    };